import React from "react";

const DEFAULT_CLASSES = {
  container:
    "token-monospace f5 lh-copy word-break-all pa2 bg-content--secondary ba br2 hairline-1 w-100"
};

const Token = ({ value, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };

  return <div className={classes.container}>{value}</div>;
};
export default Token;
